import { Row } from 'react-bootstrap';
import styled from 'styled-components';

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const MyRow = styled(Row)`
  // box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px 0px,
    rgba(0, 0, 0, 0.19) 0px 6px 20px 0px;
  // background-color: white;
  border-radius: 10px;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-top: 1rem;
`;
